import Vue from 'vue';
import App from './App';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import VueGtm from 'vue-gtm';

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';

import 'babel-polyfill';

import { store } from './store/store';
import { routes } from './routes';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Vuelidate);

Vue.use(Vuetify, {
  theme: {
    'application.theme--light': '#ffffff'
  }
});

Vue.use(Notifications);

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

const availLanguages = ['fr-be', 'nl-be', 'fr-fr', 'fr-lu'];

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  let lang = to.query.lng;
  if (lang === undefined || !availLanguages.includes(lang)) {
    lang = 'fr-be';
  }
  loadLanguageAsync(lang).then(() => next());
});

Vue.use(VueGtm, {
  id: 'GTM-M4T893G',
  enabled: true,
  debug: false,
  vueRouter: router
});

const i18n = new VueI18n({});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  return lang;
}

export function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    return System.import(
      /* webpackChunkName: "lang[request]" */ `./assets/i18n/${lang}`
    ).then(msgs => {
      i18n.setLocaleMessage(lang, msgs);
      return setI18nLanguage(lang);
    });
  }
  return Promise.resolve(lang);
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n: i18n,
  store: store,
  router: router,
  render: h => h(App),
  created() {
    firebase.initializeApp({
      apiKey: 'AIzaSyCjtKQ1EqmRqPehByIxXVY_Gl54pk0c6e8',
      authDomain: 'crashstickers.firebaseapp.com',
      databaseURL: 'https://crashstickers.firebaseio.com',
      projectId: 'crashstickers',
      storageBucket: 'crashstickers.appspot.com'
    });
  }
});



// WEBPACK FOOTER //
// ./src/main.js